import { RangeState } from '../../../hooks/date';
import { usePrefixCls } from '@okee-uikit/react-config';
export function useDateState(prefix) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isToday = state.isToday,
      selectedState = state.selectedState,
      disabledState = state.disabledState,
      tryingSelectedState = state.tryingSelectedState,
      gridState = state.gridState;
  var outRange = gridState === RangeState.PREV || gridState === RangeState.NEXT;
  return usePrefixCls(prefix, {
    selected: !outRange && (selectedState === RangeState.START || selectedState === RangeState.END || selectedState === RangeState.SINGLE),
    disabled: disabledState === RangeState.START || disabledState === RangeState.END || disabledState === RangeState.IN || disabledState === RangeState.SINGLE,
    grid: gridState,
    today: isToday,
    trying: tryingSelectedState === RangeState.START
  }, true);
}